export function isNoneNull(...args: any[]) {
  for (const arg of args) {
    if (arg === null) { return false }
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/isNoneNull.ts